const AuthView = {
  ACTION: "ACTION",
  SIGN_UP: "SIGN_UP",
  RESET_PASSWORD: "RESET_PASSWORD"
};

export default AuthView;
